module.exports = {
    handle: (e, data) => {

        if (data.error) {
            return;
        }

        if (typeof connectif === 'undefined' || !connectif) {
            return;
        }

        connectif.managed.sendEvents([
            {type: "login"}
        ]);
    }
}
